import f from "./tools/semver-compare.js";
import l from "./helpers/isObject.js";
function a(n) {
  "@babel/helpers - typeof";

  return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (t) {
    return typeof t;
  } : function (t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, a(n);
}
function o(n, t) {
  if (!(n instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function y(n, t) {
  for (var e = 0; e < t.length; e++) {
    var i = t[e];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(n, v(i.key), i);
  }
}
function u(n, t, e) {
  return t && y(n.prototype, t), Object.defineProperty(n, "prototype", {
    writable: !1
  }), n;
}
function v(n) {
  var t = P(n, "string");
  return a(t) == "symbol" ? t : t + "";
}
function P(n, t) {
  if (a(n) != "object" || !n) return n;
  var e = n[Symbol.toPrimitive];
  if (e !== void 0) {
    var i = e.call(n, t);
    if (a(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var d = "1.2.0",
  p = "1.7.35",
  h = " ext. ",
  C = /^\d+$/,
  b = function () {
    function n(t) {
      o(this, n), _(t), this.metadata = t, m.call(this, t);
    }
    return u(n, [{
      key: "getCountries",
      value: function value() {
        return Object.keys(this.metadata.countries).filter(function (e) {
          return e !== "001";
        });
      }
    }, {
      key: "getCountryMetadata",
      value: function value(e) {
        return this.metadata.countries[e];
      }
    }, {
      key: "nonGeographic",
      value: function value() {
        if (!(this.v1 || this.v2 || this.v3)) return this.metadata.nonGeographic || this.metadata.nonGeographical;
      }
    }, {
      key: "hasCountry",
      value: function value(e) {
        return this.getCountryMetadata(e) !== void 0;
      }
    }, {
      key: "hasCallingCode",
      value: function value(e) {
        if (this.getCountryCodesForCallingCode(e)) return !0;
        if (this.nonGeographic()) {
          if (this.nonGeographic()[e]) return !0;
        } else {
          var i = this.countryCallingCodes()[e];
          if (i && i.length === 1 && i[0] === "001") return !0;
        }
      }
    }, {
      key: "isNonGeographicCallingCode",
      value: function value(e) {
        return this.nonGeographic() ? !!this.nonGeographic()[e] : !this.getCountryCodesForCallingCode(e);
      }
    }, {
      key: "country",
      value: function value(e) {
        return this.selectNumberingPlan(e);
      }
    }, {
      key: "selectNumberingPlan",
      value: function value(e, i) {
        if (e && C.test(e) && (i = e, e = null), e && e !== "001") {
          if (!this.hasCountry(e)) throw new Error("Unknown country: ".concat(e));
          this.numberingPlan = new g(this.getCountryMetadata(e), this);
        } else if (i) {
          if (!this.hasCallingCode(i)) throw new Error("Unknown calling code: ".concat(i));
          this.numberingPlan = new g(this.getNumberingPlanMetadata(i), this);
        } else this.numberingPlan = void 0;
        return this;
      }
    }, {
      key: "getCountryCodesForCallingCode",
      value: function value(e) {
        var i = this.countryCallingCodes()[e];
        if (i) return i.length === 1 && i[0].length === 3 ? void 0 : i;
      }
    }, {
      key: "getCountryCodeForCallingCode",
      value: function value(e) {
        var i = this.getCountryCodesForCallingCode(e);
        if (i) return i[0];
      }
    }, {
      key: "getNumberingPlanMetadata",
      value: function value(e) {
        var i = this.getCountryCodeForCallingCode(e);
        if (i) return this.getCountryMetadata(i);
        if (this.nonGeographic()) {
          var r = this.nonGeographic()[e];
          if (r) return r;
        } else {
          var s = this.countryCallingCodes()[e];
          if (s && s.length === 1 && s[0] === "001") return this.metadata.countries["001"];
        }
      }
    }, {
      key: "countryCallingCode",
      value: function value() {
        return this.numberingPlan.callingCode();
      }
    }, {
      key: "IDDPrefix",
      value: function value() {
        return this.numberingPlan.IDDPrefix();
      }
    }, {
      key: "defaultIDDPrefix",
      value: function value() {
        return this.numberingPlan.defaultIDDPrefix();
      }
    }, {
      key: "nationalNumberPattern",
      value: function value() {
        return this.numberingPlan.nationalNumberPattern();
      }
    }, {
      key: "possibleLengths",
      value: function value() {
        return this.numberingPlan.possibleLengths();
      }
    }, {
      key: "formats",
      value: function value() {
        return this.numberingPlan.formats();
      }
    }, {
      key: "nationalPrefixForParsing",
      value: function value() {
        return this.numberingPlan.nationalPrefixForParsing();
      }
    }, {
      key: "nationalPrefixTransformRule",
      value: function value() {
        return this.numberingPlan.nationalPrefixTransformRule();
      }
    }, {
      key: "leadingDigits",
      value: function value() {
        return this.numberingPlan.leadingDigits();
      }
    }, {
      key: "hasTypes",
      value: function value() {
        return this.numberingPlan.hasTypes();
      }
    }, {
      key: "type",
      value: function value(e) {
        return this.numberingPlan.type(e);
      }
    }, {
      key: "ext",
      value: function value() {
        return this.numberingPlan.ext();
      }
    }, {
      key: "countryCallingCodes",
      value: function value() {
        return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
      }
    }, {
      key: "chooseCountryByCountryCallingCode",
      value: function value(e) {
        return this.selectNumberingPlan(e);
      }
    }, {
      key: "hasSelectedNumberingPlan",
      value: function value() {
        return this.numberingPlan !== void 0;
      }
    }]);
  }(),
  g = function () {
    function n(t, e) {
      o(this, n), this.globalMetadataObject = e, this.metadata = t, m.call(this, e.metadata);
    }
    return u(n, [{
      key: "callingCode",
      value: function value() {
        return this.metadata[0];
      }
    }, {
      key: "getDefaultCountryMetadataForRegion",
      value: function value() {
        return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
      }
    }, {
      key: "IDDPrefix",
      value: function value() {
        if (!(this.v1 || this.v2)) return this.metadata[1];
      }
    }, {
      key: "defaultIDDPrefix",
      value: function value() {
        if (!(this.v1 || this.v2)) return this.metadata[12];
      }
    }, {
      key: "nationalNumberPattern",
      value: function value() {
        return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
      }
    }, {
      key: "possibleLengths",
      value: function value() {
        if (!this.v1) return this.metadata[this.v2 ? 2 : 3];
      }
    }, {
      key: "_getFormats",
      value: function value(e) {
        return e[this.v1 ? 2 : this.v2 ? 3 : 4];
      }
    }, {
      key: "formats",
      value: function value() {
        var e = this,
          i = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
        return i.map(function (r) {
          return new F(r, e);
        });
      }
    }, {
      key: "nationalPrefix",
      value: function value() {
        return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
      }
    }, {
      key: "_getNationalPrefixFormattingRule",
      value: function value(e) {
        return e[this.v1 ? 4 : this.v2 ? 5 : 6];
      }
    }, {
      key: "nationalPrefixFormattingRule",
      value: function value() {
        return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
      }
    }, {
      key: "_nationalPrefixForParsing",
      value: function value() {
        return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
      }
    }, {
      key: "nationalPrefixForParsing",
      value: function value() {
        return this._nationalPrefixForParsing() || this.nationalPrefix();
      }
    }, {
      key: "nationalPrefixTransformRule",
      value: function value() {
        return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
      }
    }, {
      key: "_getNationalPrefixIsOptionalWhenFormatting",
      value: function value() {
        return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
      }
    }, {
      key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
      value: function value() {
        return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
      }
    }, {
      key: "leadingDigits",
      value: function value() {
        return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
      }
    }, {
      key: "types",
      value: function value() {
        return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
      }
    }, {
      key: "hasTypes",
      value: function value() {
        return this.types() && this.types().length === 0 ? !1 : !!this.types();
      }
    }, {
      key: "type",
      value: function value(e) {
        if (this.hasTypes() && c(this.types(), e)) return new x(c(this.types(), e), this);
      }
    }, {
      key: "ext",
      value: function value() {
        return this.v1 || this.v2 ? h : this.metadata[13] || h;
      }
    }]);
  }(),
  F = function () {
    function n(t, e) {
      o(this, n), this._format = t, this.metadata = e;
    }
    return u(n, [{
      key: "pattern",
      value: function value() {
        return this._format[0];
      }
    }, {
      key: "format",
      value: function value() {
        return this._format[1];
      }
    }, {
      key: "leadingDigitsPatterns",
      value: function value() {
        return this._format[2] || [];
      }
    }, {
      key: "nationalPrefixFormattingRule",
      value: function value() {
        return this._format[3] || this.metadata.nationalPrefixFormattingRule();
      }
    }, {
      key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
      value: function value() {
        return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
      }
    }, {
      key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
      value: function value() {
        return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
      }
    }, {
      key: "usesNationalPrefix",
      value: function value() {
        return !!(this.nationalPrefixFormattingRule() && !k.test(this.nationalPrefixFormattingRule()));
      }
    }, {
      key: "internationalFormat",
      value: function value() {
        return this._format[5] || this.format();
      }
    }]);
  }(),
  k = /^\(?\$1\)?$/,
  x = function () {
    function n(t, e) {
      o(this, n), this.type = t, this.metadata = e;
    }
    return u(n, [{
      key: "pattern",
      value: function value() {
        return this.metadata.v1 ? this.type : this.type[0];
      }
    }, {
      key: "possibleLengths",
      value: function value() {
        if (!this.metadata.v1) return this.type[1] || this.metadata.possibleLengths();
      }
    }]);
  }();
function c(n, t) {
  switch (t) {
    case "FIXED_LINE":
      return n[0];
    case "MOBILE":
      return n[1];
    case "TOLL_FREE":
      return n[2];
    case "PREMIUM_RATE":
      return n[3];
    case "PERSONAL_NUMBER":
      return n[4];
    case "VOICEMAIL":
      return n[5];
    case "UAN":
      return n[6];
    case "PAGER":
      return n[7];
    case "VOIP":
      return n[8];
    case "SHARED_COST":
      return n[9];
  }
}
function _(n) {
  if (!n) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!l(n) || !l(n.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(l(n) ? "an object of shape: { " + Object.keys(n).join(", ") + " }" : "a " + N(n) + ": " + n, "."));
}
var N = function N(t) {
  return a(t);
};
function R(n, t) {
  if (t = new b(t), t.hasCountry(n)) return t.country(n).countryCallingCode();
  throw new Error("Unknown country: ".concat(n));
}
function O(n, t) {
  return t.countries.hasOwnProperty(n);
}
function m(n) {
  var t = n.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? f(t, d) === -1 ? this.v2 = !0 : f(t, p) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
export { b as default, R as getCountryCallingCode, O as isSupportedCountry, _ as validateMetadata };